import { Box, FlexBox } from '@dixa/lib-shared-habla';
import classNames from 'classnames';

import styles from './colorOption.module.scss';

interface Props {
  color: string;
  title: string;
  onClick: () => void;
  isSelected: boolean;
}

export function ColorOption({
  color,
  title,
  isSelected,
  onClick,
}: Props): JSX.Element {
  return (
    <FlexBox flexDirection="column" gap="200" alignItems="center">
      <Box
        onClick={onClick}
        style={{ background: color }}
        className={classNames(styles.colorBox, {
          [styles.colorBoxSelected]: isSelected,
        })}
      />
      <div className={styles.title}>{title}</div>
    </FlexBox>
  );
}
